import React, { useState, useEffect, useRef } from 'react';
import AdminContactService from '../../api/services/AdminContactService';
import MainPagetitle from '../../layouts/MainPagetitle';
import VoucherService from '../../api/services/VoucherService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import moment from 'moment';
import AdminNewsletterService from '../../api/services/AdminNewsletterService';
import PaymentDetailService from '../../api/services/PaymentDetailService';
import TripReviewService from '../../api/services/TripReviewService';
import { downloadExcel } from 'react-export-table-to-excel';
import { Link, useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import { Dropdown } from 'react-bootstrap';
import CustomerDatabaseService from '../../api/services/CustomerDatabaseService';
const Database = () => {
    const navigate = useNavigate();
    const [voucher, setVoucher] = useState([]);
    const [PaymentList, setPaymentList] = useState([]);
    const [isLoading, setisloading] = useState(true);
    const [travel, settravel] = useState([]);
    const [ContactList, setContactList] = useState([]);
    const [SaleContactList, setSaleContactList] = useState([]);
    const [NewslettersList, setNewslettersList] = useState([]);
    const [searchText, setSearchText] = useState('latest');

    const tableRef = useRef(null);
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {
            getCustomerDatabaseList();

        }
        else {
            navigate('/')
        }
    }, []);
    const getCustomerDatabaseList = async () => {
        try {
            let userdata = {
                "sortby": searchText ? searchText : 'latest'
            }
            let responseData = await CustomerDatabaseService.index(userdata).json()
            // var newsletterslist = responseData.data.filter(function (item) {
            //     return item.tabletype == "newsletters"
            // });
            // var contactlist = responseData.data.filter(function (item) {
            //     return item.tabletype == "contact"
            // });
            // var orderlist = responseData.data.filter(function (item) {
            //     return item.tabletype == "order_details"
            // });
            // var voucherslist = responseData.data.filter(function (item) {
            //     return item.tabletype == "vouchers"
            // });
            // var tripplanlist = responseData.data.filter(function (item) {
            //     return item.tabletype == "tripplan"
            // });
            setContactList(responseData.data)
            // setNewslettersList(newsletterslist)
            // setPaymentList(orderlist)
            // // setSaleContactList(responseData.sale_contacts.data)
            // settravel(tripplanlist)
            // setVoucher(voucherslist)

            setisloading(false);
        } catch (error) {

        }
    };

    const handleVoucherDelete = async (e) => {

        try {
            let responseData = await VoucherService.Voucherdestroy(e).json()
            if (responseData.status === true) {
                swal("Record Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getCustomerDatabaseList()
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message)
            }
        }
    }
    const handlepaymentDelete = async (e) => {

        try {
            let responseData = await PaymentDetailService.Orderdestroy(e).json()
            if (responseData.status === true) {
                swal("Record Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getCustomerDatabaseList();
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message)
            }
        }
    }
    const handleTravelDelete = async (e) => {

        try {
            let responseData = await TripReviewService.tripdestroy(e).json()
            if (responseData.status === true) {
                swal("Record Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getCustomerDatabaseList()
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message)
            }
        }
    }

    const handleContactDelete = async (e) => {

        try {
            let responseData = await AdminContactService.destroy(e).json()
            if (responseData.status === true) {
                swal("Record Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getCustomerDatabaseList()
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message)
            }
        }
    }

    const handleSaleDelete = async (e) => {

        try {
            let responseData = await AdminContactService.salecontactdestroy(e).json()
            if (responseData.status === true) {
                swal("Record Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getCustomerDatabaseList()
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message)
            }
        }
    }
    const handleDelete = async (e) => {

        try {
            let responseData = await AdminNewsletterService.destroy(e).json()
            if (responseData.status === true) {
                swal("Record Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getCustomerDatabaseList()
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                // setError(errorJson.message)
            }
        }
    }
    // const header = ["No.", "Type", "First & Last Name", "Email","Phone Number","Date of Birth","Street, Address Addition, Zip"," City, Country","Language","Password"]
    const header = ["No.", "First & Last Name", "Email", "Phone Number", "Date of Birth", "Street, Address Addition, Zip", " City, Country", "Language", "Password"]
    const getTableData = () => {
        const table = tableRef.current;
        const body = Array.from(table.querySelectorAll("tbody tr")).map((tr) =>
            Array.from(tr.querySelectorAll("td")).map((td) => td.innerText)
        );

        return { body };
    };
    function useDownloadExcel() {
        const { body } = getTableData();
        downloadExcel({
            fileName: "Customer Listing",
            sheet: "Customer",
            tablePayload: {
                header,
                body: body

            },
        });
    }
    const handleSearch = async (e) => {
        setisloading(true);
        setSearchText(e);  // Update the selected option when an item is clicked

        try {
            let userdata = {
                "sortby": e

                // "name": searchText ? searchText : "",
                // "created_date": ""
            }
            let responseData = await CustomerDatabaseService.index(userdata).json()
            // var newsletterslist = responseData.data.filter(function (item) {
            //     return item.tabletype == "newsletters"
            // });
            // var contactlist = responseData.data.filter(function (item) {
            //     return item.tabletype == "contact"
            // });
            // var orderlist = responseData.data.filter(function (item) {
            //     return item.tabletype == "order_details"
            // });
            // var voucherslist = responseData.data.filter(function (item) {
            //     return item.tabletype == "vouchers"
            // });
            // var tripplanlist = responseData.data.filter(function (item) {
            //     return item.tabletype == "tripplan"
            // });
            setContactList(responseData.data)
            // setNewslettersList(newsletterslist)
            // setPaymentList(orderlist)
            // // setSaleContactList(responseData.sale_contacts.data)
            // settravel(tripplanlist)
            // setVoucher(voucherslist)

            setisloading(false);
        } catch (error) {

        }
        // Implement your search functionality here
        console.log('Searching for:', searchText);
    }

    const handleStatusChange = async (email, type) => {
    
            try {
                  const payload = {
                        email:email,
                        status:type
                    }
    
                let responseData = await AdminNewsletterService.updatestatus(payload).json()
                if (responseData.status === true) {
                    getCustomerDatabaseList()
                }
            } catch (error) {
                if (error.name === 'HTTPError') {
                    const errorJson = await error.response.json();
                }
            }
        }
    
    return (
        <>
            <MainPagetitle mainTitle="Customer Database" pageTitle={'Customer Database'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Customer Listing</h4>
                                        <div className='d-flex'>
                                            {/* <input
                                            type="text"
                                            className="form-control form-control-sm ms-1 search-input" 
                                            placeholder="Search..."
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        /> */}
                                            <Dropdown onSelect={handleSearch} >
                                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                    {searchText === 'latest' ? 'Filter' : 'A-Z'}

                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item eventKey="latest" active={searchText === 'latest'}>Creation Date</Dropdown.Item>
                                                    <Dropdown.Item eventKey="a-z" active={searchText === 'a-z'}>A-Z</Dropdown.Item>

                                                </Dropdown.Menu>
                                            </Dropdown>
                                            {/* <select className="form-control" name="sort_by" onChange={(e) => handleSearch(e.target.value)}>
                                                <option value="a-z">A-Z</option>
                                                <option value="latest">Creation Date</option>

                                            </select>

                                            <button
                                                className="btn btn-info btn-sm ms-1"
                                                onClick={handleSearch}
                                            >
                                                Filter
                                            </button> */}

                                            <button onClick={useDownloadExcel} className="btn btn-primary btn-sm ms-1"> Export Excel </button>
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0" ref={tableRef}>
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    {/* <th>Type</th> */}
                                                    <th>First & Last Name</th>
                                                    <th>Email</th>
                                                    <th>Phone Number</th>
                                                    <th>Date of Birth</th>
                                                    <th>
                                                        Street, Address Addition, Zip
                                                    </th>
                                                    <th>
                                                        City, Country
                                                    </th>
                                                    <th>Language</th>

                                                    <th>Password</th>
                                                    <th>Creation Date</th>
                                                    <th>Status</th>
                                                    {/* <th style={{ textAlign: 'right' }}><strong >Action</strong></th> */}

                                                </tr>
                                            </thead>
                                            <tbody>

                                                {/* {ContactList.map((item, index) => {
                                                  
                                                    return (
                                                        item.tabletype === "vouchers"
                                                            ?
                                                            <tr key={index}>
                                                                
                                                                <td>
                                                                    <div className="products">
                                                                        <h6>{item.first_last_name}</h6>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="products">
                                                                        <h6>{item.email}</h6>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <h6>{item.phone ? item.phone : "_"}</h6>
                                                                </td>
                                                                <td>
                                                                    <h6>{moment(item.dob).format('DD/MM/YYYY')}</h6>
                                                                </td>
                                                                <td>
                                                                    <h6>{item.street ? item.street : "_"},{item.address_addition ? item.address_addition : "_"},{item.zip_code ? item.zip_code : "_"}</h6>
                                                                </td>
                                                                <td>
                                                                    <h6>{item.city ? item.city : "_"},{item.country ? item.country : "_"}</h6>
                                                                </td>
                                                                <td>
                                                                    <h6>{item.lng ? item.lng === 'en' ? "English" : "German" : "_"}</h6>
                                                                </td>
                                                                <td>
                                                                    <h6> _</h6>
                                                                </td>
                                                                <td>
                                                                    <Link
                                                                        onClick={() =>
                                                                            swal({
                                                                                title: "Are you sure?",
                                                                                text: "Once deleted, you will not be able to recover this data!",
                                                                                icon: "warning",
                                                                                buttons: true,
                                                                                dangerMode: true,
                                                                            }).then((willDelete) => {
                                                                                if (willDelete) {
                                                                                    (handleVoucherDelete(item.id));
                                                                                }
                                                                            })
                                                                        }

                                                                        className="btn btn-danger shadow btn-xs sharp"
                                                                    >
                                                                        <i className="fa fa-trash"></i>
                                                                    </Link>
                                                                </td>

                                                            </tr>
                                                            : ""
                                                    )
                                                })} */}
                                                {ContactList.map((item, index) => {

                                                    return (

                                                        <tr key={index}>
                                                            <td>
                                                                <div className="products">
                                                                    <h6>{index + 1}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="products">
                                                                    <h6>{item.name ? item.name : "_"}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="products">
                                                                    <h6>{item.email ? item.email : "_"}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h6>{item.phone ? item.phone : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6>{item.dob ? moment(item.dob).format('DD/MM/YYYY') : "_"}</h6>
                                                            </td>
                                                            {/* {
                                                                item.tabletype === "order_details"
                                                                    ?
                                                                    <>
                                                                        <td>

                                                                            <h6>{item.street ? item.street : "_"}</h6>
                                                                        </td>

                                                                        <td> <h6>{item.city_country ? item.city_country : "_"}</h6></td>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <td>

                                                                            <h6>{item.street ? item.street : "_"},{item.address_addition ? item.address_addition : "_"},{item.zip_code ? item.zip_code : "_"}</h6>
                                                                        </td>

                                                                        <td> <h6>{item.city ? item.city : "_"},{item.country ? item.country : "_"}</h6></td>
                                                                    </>

                                                            } */}

                                                            <td>

                                                                <h6>{item.street ? item.street : "_"},{item.address_addition ? item.address_addition : "_"},{item.zip_code ? item.zip_code : "_"}</h6>
                                                            </td>

                                                            <td>
                                                                <h6>{item.city_country ? item.city_country :
                                                                    <>
                                                                        {item.city ? item.city : "_"}, {item.country ? item.country : "_"}
                                                                    </>
                                                                }</h6>
                                                            </td>


                                                            <td>
                                                                <h6>{item.lng ? item.lng === 'en' ? "English" : "German" : "_"}</h6>
                                                            </td>

                                                            <td>
                                                                <h6>{item.user_password ? item.user_password : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6>{moment(item.created_at).format('DD-MM-YYYY HH:mm')}</h6>
                                                            </td>
                                                            <td>
                                                                {(item.status_flag == 0 || item.status_flag === null) ? (
                                                                    <span
                                                                        className="btn btn-success btn-sm ms-1"
                                                                        onClick={() => handleStatusChange(item.email, 1)}
                                                                    >
                                                                        No Problems
                                                                    </span>
                                                                ) : item.status_flag == 1 ? (
                                                                    <span
                                                                        className="btn btn-warning btn-sm ms-1"
                                                                        onClick={() => handleStatusChange(item.email, 2)}
                                                                    >
                                                                        Damage
                                                                    </span>
                                                                ) : item.status_flag == 2 ? (
                                                                    <span
                                                                        className="btn btn-danger btn-sm ms-1"
                                                                        onClick={() => handleStatusChange(item.email, 0)}
                                                                    >
                                                                        Blocked
                                                                    </span>
                                                                ) : null}
                                                            </td>


                                                        </tr>

                                                    )
                                                })}
                                                {/* {ContactList.map((item, index) => (
                                                    item.tabletype === "tripplan"
                                                        ?
                                                        <tr key={index}>
                                                            
                                                         
                                                            <td>
                                                                <div className="products">
                                                                    <h6>{item.first_last_name}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="products">
                                                                    <h6>{item.email}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h6>{item.phone ? item.phone : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6>{moment(item.dob).format('DD/MM/YYYY')}</h6>
                                                            </td>
                                                            <td>
                                                                <h6>{item.street ? item.street : "_"},{item.address_addition ? item.address_addition : "_"},{item.zip_code ? item.zip_code : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6>{item.city ? item.city : "_"},{item.country ? item.country : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6>{item.lng ? item.lng === 'en' ? "English" : "German" : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6> _</h6>
                                                            </td>
                                                            <td>
                                                                <Link
                                                                    onClick={() =>
                                                                        swal({
                                                                            title: "Are you sure?",
                                                                            text: "Once deleted, you will not be able to recover this data!",
                                                                            icon: "warning",
                                                                            buttons: true,
                                                                            dangerMode: true,
                                                                        }).then((willDelete) => {
                                                                            if (willDelete) {
                                                                                (handleTravelDelete(item.id));
                                                                            }
                                                                        })
                                                                    }

                                                                    className="btn btn-danger shadow btn-xs sharp"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </Link>
                                                            </td>

                                                        </tr>
                                                        : ""
                                                ))} */}
                                                {/* {ContactList.map((item, index) => (
                                                    item.tabletype === "contact"
                                                        ?
                                                        <tr key={index}>
                                                            
                                                            <td>
                                                                <div className="products">
                                                                    <h6>{item.firstName ? item.firstName : "_"}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="products">
                                                                    <h6>{item.email ? item.email : "_"}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h6>{item.phone ? item.phone : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6>{moment(item.dob).format('DD/MM/YYYY') ? moment(item.dob).format('DD/MM/YYYY') : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6>{item.street ? item.street : "_"}</h6>
                                                            </td>

                                                            <td>
                                                                <h6>{item.country ? item.country : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6>{item.lng ? item.lng === 'en' ? "English" : "German" : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6> _</h6>
                                                            </td>
                                                            <td>
                                                                <Link
                                                                    onClick={() =>
                                                                        swal({
                                                                            title: "Are you sure?",
                                                                            text: "Once deleted, you will not be able to recover this data!",
                                                                            icon: "warning",
                                                                            buttons: true,
                                                                            dangerMode: true,
                                                                        }).then((willDelete) => {
                                                                            if (willDelete) {
                                                                                (handleContactDelete(item.id));
                                                                            }
                                                                        })
                                                                    }

                                                                    className="btn btn-danger shadow btn-xs sharp"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                        : ""
                                                ))} */}
                                                {/* {ContactList.map((item, index) => (
                                                    item.tabletype === "sale_contacts"
                                                        ?
                                                        <tr key={index}>
                                                           
                                                            <td>
                                                                <div className="products">
                                                                    <h6>{item.firstName}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="products">
                                                                    <h6>{item.email}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <h6>{item.phone ? item.phone : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6>{moment(item.dob).format('DD/MM/YYYY')}</h6>
                                                            </td>
                                                            <td>
                                                                <h6>{item.street ? item.street : "_"}</h6>
                                                            </td>

                                                            <td>
                                                                <h6>{item.lng ? item.lng === 'en' ? "English" : "German" : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6> _</h6>
                                                            </td>
                                                            <td>
                                                                <Link
                                                                    onClick={() =>
                                                                        swal({
                                                                            title: "Are you sure?",
                                                                            text: "Once deleted, you will not be able to recover this data!",
                                                                            icon: "warning",
                                                                            buttons: true,
                                                                            dangerMode: true,
                                                                        }).then((willDelete) => {
                                                                            if (willDelete) {
                                                                                (handleSaleDelete(item.id));
                                                                            }
                                                                        })
                                                                    }

                                                                    className="btn btn-danger shadow btn-xs sharp"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </Link>
                                                            </td>

                                                        </tr>
                                                        : ""
                                                ))} */}
                                                {/* {NewslettersList.map((item, index) => (
                                                    item.tabletype === "newsletters"
                                                        ?
                                                        <tr key={index}>
                                                          
                                                            <td>
                                                                <div className="products">
                                                                    <h6>{item.first_name ? item.first_name : "_"}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="products">
                                                                    <h6>{item.email ? item.email : "_"}</h6>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="products"> <h6>{item.phone ? item.phone : "_" ? item.phone ? item.phone : "_" : '_'}</h6></div>
                                                            </td>
                                                            <td>
                                                                <div className="products"><h6>_</h6></div>
                                                            </td>
                                                            <td>
                                                                <div className="products"><h6>{item.street ? item.street : "_" ? item.street ? item.street : "_" : "_"}</h6></div>
                                                            </td>

                                                            <td>
                                                                <div className="products"><h6>{item.country ? item.country : "_" ? item.country ? item.country : "_" : "_"}</h6></div>
                                                            </td>
                                                            <td>

                                                                <h6>{item.lng ? item.lng === 'en' ? "English" : "German" : "_"}</h6>
                                                            </td>
                                                            <td>
                                                                <h6> _</h6>
                                                            </td>
                                                            <td>
                                                                <Link
                                                                    onClick={() =>
                                                                        swal({
                                                                            title: "Are you sure?",
                                                                            text: "Once deleted, you will not be able to recover this data!",
                                                                            icon: "warning",
                                                                            buttons: true,
                                                                            dangerMode: true,
                                                                        }).then((willDelete) => {
                                                                            if (willDelete) {
                                                                                (handleDelete(item.id));
                                                                            }
                                                                        })
                                                                    }

                                                                    className="btn btn-danger shadow btn-xs sharp"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </Link>
                                                            </td>

                                                        </tr>
                                                        : ""
                                                ))} */}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default Database;